import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { LinkedProcessItemResult } from '@core/entities/linkedProcesses'
import {
  checklistKeys,
  RequestTypes,
} from '@core/react-query/features/checklists/checklist'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const checklistLinkedTasksTransform: (
  data,
) => Array<LinkedProcessItemResult> = (data) => {
  return data?.linkedProcessItemResults.map((linkedProcessItemResult) => {
    return LinkedProcessItemResult.new(linkedProcessItemResult)
  })
}

export const useGetChecklistLinkedTasks = (
  payload: RequestTypes['getChecklistLinkedTasks'],
  options?: UseQueryOptions<LinkedProcessItemResult[], RequestErrorType>,
) => {
  return useQuery({
    select: checklistLinkedTasksTransform,
    ...checklistKeys.byId(payload)._ctx.linkedTasks,
    ...options,
  })
}
